import crestUrl from './polonia-forged-crest.png';
import impactSound from './forged-impact.wav';
import { useEffect, useMemo, useRef, useState } from 'react';

export function SplitCrestIntro({ trigger = 0 }: { trigger?: number }) {
  const reducedMotion = useMemo(
    () => typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches,
    [],
  );
  const [visible, setVisible] = useState(true);
  const audioRef = useRef<HTMLAudioElement | null>(null);

  useEffect(() => {
    setVisible(true);
    const lifetime = reducedMotion ? 1100 : 3150;

    if (!reducedMotion) {
      const audio = new Audio(impactSound);
      audio.volume = 0.22;
      audio.preload = 'auto';
      audioRef.current = audio;

      const soundTimer = window.setTimeout(() => {
        void audio.play().catch(() => {
          // iOS/Android browser media policy can block autoplay.
          // Visual branding remains complete without audio.
        });
      }, 760);

      const timer = window.setTimeout(() => setVisible(false), lifetime);
      return () => {
        window.clearTimeout(timer);
        window.clearTimeout(soundTimer);
        audio.pause();
        audioRef.current = null;
      };
    }

    const timer = window.setTimeout(() => setVisible(false), lifetime);
    return () => window.clearTimeout(timer);
  }, [trigger, reducedMotion]);

  if (!visible) return null;

  return (
    <div className={`energy-crack-intro ${reducedMotion ? 'reduced' : ''}`} aria-hidden="true">
      <div className="energy-void" />
      <div className="energy-floor-glow" />

      <svg className="energy-cracks" viewBox="0 0 1000 1000" preserveAspectRatio="none">
        <path className="crack c1" d="M500 525 L455 570 L430 635 L365 690 L340 760" />
        <path className="crack c2" d="M500 525 L548 572 L585 635 L650 680 L690 760" />
        <path className="crack c3" d="M500 525 L500 608 L472 690 L480 790" />
        <path className="crack c4" d="M500 525 L415 535 L350 515 L285 555" />
        <path className="crack c5" d="M500 525 L590 535 L675 510 L735 550" />
        <path className="crack c6" d="M500 525 L445 485 L402 430 L338 410" />
        <path className="crack c7" d="M500 525 L560 482 L610 425 L680 400" />
      </svg>

      <div className="energy-impact-ring ring-one" />
      <div className="energy-impact-ring ring-two" />
      <div className="energy-pulse" />

      <div className="energy-particles">
        {Array.from({ length: 18 }).map((_, index) => <i key={index} />)}
      </div>

      <div className="energy-crest-drop">
        <img src={crestUrl} alt="" />
        <span className="energy-crest-sheen" />
      </div>

      <div className="energy-intro-kicker">ENERGY STACK · SHARED FOOTBALL INTELLIGENCE</div>

      <div className="energy-title">
        <strong>POLONIA GLASGOW AFC</strong>
        <span>ELITE COACH CLOUD</span>
      </div>

      <div className="energy-intro-progress"><i /></div>

      <div className="energy-camera-transition" />
    </div>
  );
}
